// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"ba278fac","542":"d5476d7c","787":"c4a36281"}[chunkId] + ".chunk.js";
};